/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-console */

import { Image, Plan, Poi, PoiCategory, Step } from '@tripian/model/api/v3';
import IPoiCategoryParent from '@tripian/model/api/v3/models/IPoiCategoryParent';
import { trace, debug, info, log, warn, error } from './testResults';
import ITripState from '../redux/model/ITripState';

import config from './config';

export const testTrip = (tripState: ITripState) => {
  debug('testTrip started...');

  /**
   * TODO
   */

  if (tripState.plans) {
    testPlans(tripState.plans);
  }

  // trace('hello');
  // debug('hello');
  // info('hello');
  // log('hello');
  // warn('hello');
  // error('hello');

  debug(tripState);
  debug(config);
};

export const testPlans = (plans: Plan[]) => {
  debug('testPlans called');

  /**
   * TODO
   */

  plans.forEach((p) => testPlan(p));
};

export const testPlan = (plan: Plan) => {
  debug('testPlan called...');

  /**
   * TODO
   */

  plan.steps.forEach((s) => testStep(s));
};

export const testStep = (step: Step) => {
  debug('testStep called...');

  /**
   * TODO
   */

  testPoi(step.poi);
};

export const testPoi = (poi: Poi) => {
  debug('testPoi called...');

  /**
   * TODO
   */

  testPoiCategories(poi.category, poi);
  testPoiGallery(poi.gallery, poi);
};

export const testPoiParentCategory = (poiCategoryParent: IPoiCategoryParent, poi: Poi) => {
  debug('testPoiParentCategory called...');

  if (poiCategoryParent === undefined) error('testPoiParentCategory: parent categories is undefined.', poi);

  if (poiCategoryParent.id === null || poiCategoryParent.id < 1) error('testPoiParentCategory: Invalid parent poi category id.', poi);

  if (poiCategoryParent.name === '') error('testPoiParentCategory: Invalid parent poi category name.', poi);

  /**
   * TODO
   */
};

export const testPoiCategories = (poiCategories: PoiCategory[], poi: Poi) => {
  debug('testPoiCategories called...');

  if (poiCategories.length === 0) error('testPoiCategories: categories is empty.', poi);

  poiCategories.forEach((c) => {
    if (c.id < 1) error('testPoiCategories: Invalid poi category id.', poi);

    if (c.name === '') error('testPoiCategories: Invalid poi category name.', poi);

    if (c.description === '') error('testPoiCategories: Invalid poi category decsription.', poi);

    if (c.parent !== null && c.parent.id !== null && c.parent?.name !== null) testPoiParentCategory(c.parent, poi);
  });

  /**
   * TODO
   */
};

export const testPoiGallery = (gallery: Image[], poi: Poi) => {
  debug('testPoiGallery called...');

  if (gallery.length < 3) debug('testPoiGallery: gallery length is too small.', poi);

  if (gallery.length === 0) error('testPoiGallery: gallery is empty.', poi);

  gallery.forEach((i) => {
    if (!i.url.startsWith('https://poi-pics.s3-eu-west-1.amazonaws.com/Place/')) error('testPoiGallery: Invalid image url format.', i, poi);
    if (i.image_owner === undefined || i.image_owner?.url === undefined || !i.image_owner.url?.startsWith('https://')) debug('testPoiGallery: Invalid image_owner or url format.', i, poi);
  });

  /**
   * TODO
   */

  debug('testPoiCategories called...');
};

export const testTrip1 = () => {
  debug('testTrip1 called');
};
